import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerificationStatusComponent } from './verification-status/verification-status.component';
import { IdentityComponent } from './identity/identity.component';
import { ClientTypeComponent } from './client-type/client-type.component';
import { SelectEmployerComponent } from './select-employer/select-employer.component';
import { EmployerListComponent } from './select-employer/employer-list/employer-list.component';

import { RouterModule, Routes } from '@angular/router';
import {
  AuthGuard,
  GuidGuard,
  IdentityGuard,
  RequiredVerificationGuard,
  SharedDesktopModule,
} from '@brightside-web/shared/desktop';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { BrightsideUiServicesModule } from '@brightside/brightside-ui-services';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedAccountModule } from '@brightside-web/shared/account';
import { EligibilityWrapperComponent } from './eligibility-wrapper/eligibility-wrapper.component';
import { UserEligibilityService } from "./user-eligibility.service";

const routes: Routes = [
  {
    path: '',
    component: EligibilityWrapperComponent,
    children: [
      { path: 'select-employer', component: SelectEmployerComponent, canActivate: [AuthGuard, GuidGuard] },
      { path: 'type', component: ClientTypeComponent, canActivate: [AuthGuard, GuidGuard] },
      { path: 'identity', component: IdentityComponent, canActivate: [AuthGuard, GuidGuard, IdentityGuard] },
      { path: 'status', component: VerificationStatusComponent, canActivate: [AuthGuard, RequiredVerificationGuard] },
    ],
  },
];

@NgModule({
  imports: [
    BrightsideUiModule,
    BrightsideUiServicesModule,
    CommonModule,
    MicroUiMoleculeModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SharedDesktopModule,
    TranslateModule,
    SharedAccountModule,
  ],
  declarations: [
    VerificationStatusComponent,
    IdentityComponent,
    ClientTypeComponent,
    SelectEmployerComponent,
    EmployerListComponent,
    EligibilityWrapperComponent,
  ],
  providers: [
    UserEligibilityService
  ]
})
export class DesktopFeatureUserEligibilityModule {}
